import {Component, Input, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {KeyValue} from "@angular/common";


@Component({
  selector: 'shipment-tracking',
  templateUrl: './shipment-tracking.component.html',
  styleUrls: ['./shipment-tracking.component.scss']
})
export class ShipmentTrackingComponent implements OnInit {

  @Input() shipmentDetails: any;
  @Input() trackingDetailsArray: any;
  @Input() trackingDetails: any;
  constructor(public platform: Platform) { }

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  ngOnInit(): void {
  }

}
